// extracted by css-extract-rspack-plugin
export default {"queryEditor":"ehJGO","editorWrapper":"gPfJy","resizableArea":"MNjP0","resizableBoxContent":"vzOFC","actionButtons":"mad0Y","readOnlyEditor":"J8nKF"};